import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Status, Priority } from '../types';
import { STATUSES, PRIORITIES, USERS } from '../store';
interface CreateIssueModalProps {
  isOpen: boolean;
  onClose: () => void;
  onCreate: (issue: any) => void;
}
export function CreateIssueModal({
  isOpen,
  onClose,
  onCreate
}: CreateIssueModalProps) {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [status, setStatus] = useState<Status>('todo');
  const [priority, setPriority] = useState<Priority>('no-priority');
  const [assigneeId, setAssigneeId] = useState<string>('');
  const inputRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    if (isOpen) {
      setTimeout(() => inputRef.current?.focus(), 100);
    } else {
      setTitle('');
      setDescription('');
      setStatus('todo');
      setPriority('no-priority');
      setAssigneeId('');
    }
  }, [isOpen]);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!title.trim()) return;
    onCreate({
      title,
      description,
      status,
      priority,
      assigneeId: assigneeId || undefined,
      labelIds: []
    });
    onClose();
  };
  return <AnimatePresence data-id="element-26">
      {isOpen && <div className="fixed inset-0 z-[100] flex items-start justify-center pt-[15vh]" data-id="element-27">
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 bg-slate-900/20 backdrop-blur-[1px]" onClick={onClose} data-id="element-28" />
          <motion.div initial={{
        opacity: 0,
        scale: 0.97,
        y: -10
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.97,
        y: -10
      }} transition={{
        duration: 0.15,
        ease: 'easeOut'
      }} className="relative w-full max-w-2xl bg-white rounded-xl shadow-linear-modal overflow-hidden" data-id="element-29">
            <form onSubmit={handleSubmit} data-id="element-30">
              <div className="p-4 border-b border-[#eef0f2]" data-id="element-31">
                <input ref={inputRef} type="text" value={title} onChange={e => setTitle(e.target.value)} placeholder="Issue title" className="w-full text-[16px] font-medium text-slate-900 border-none outline-none focus:ring-0 p-0 placeholder-slate-400" data-id="element-32" />
              </div>
              <div className="p-4" data-id="element-33">
                <textarea value={description} onChange={e => setDescription(e.target.value)} placeholder="Add description..." className="w-full text-[13px] text-slate-600 border-none outline-none focus:ring-0 p-0 min-h-[100px] resize-none placeholder-slate-400 leading-relaxed" data-id="element-34" />
              </div>

              <div className="bg-[#f7f8f9] p-3 border-t border-[#eef0f2] flex items-center justify-between" data-id="element-35">
                <div className="flex items-center space-x-2" data-id="element-36">
                  <select value={status} onChange={e => setStatus(e.target.value as Status)} className="text-[12px] border border-slate-200/80 rounded px-2 py-1 bg-white text-slate-700 focus:outline-none focus:border-[#5e6ad2] shadow-sm cursor-pointer" data-id="element-37">
                    {STATUSES.map(s => <option key={s.id} value={s.id} data-id="element-38">
                        {s.label}
                      </option>)}
                  </select>

                  <select value={priority} onChange={e => setPriority(e.target.value as Priority)} className="text-[12px] border border-slate-200/80 rounded px-2 py-1 bg-white text-slate-700 focus:outline-none focus:border-[#5e6ad2] shadow-sm cursor-pointer" data-id="element-39">
                    {PRIORITIES.map(p => <option key={p.id} value={p.id} data-id="element-40">
                        {p.label}
                      </option>)}
                  </select>

                  <select value={assigneeId} onChange={e => setAssigneeId(e.target.value)} className="text-[12px] border border-slate-200/80 rounded px-2 py-1 bg-white text-slate-700 focus:outline-none focus:border-[#5e6ad2] shadow-sm cursor-pointer" data-id="element-41">
                    <option value="" data-id="element-42">Assignee</option>
                    {USERS.map(u => <option key={u.id} value={u.id} data-id="element-43">
                        {u.name}
                      </option>)}
                  </select>
                </div>

                <div className="flex items-center space-x-3" data-id="element-44">
                  <button type="button" onClick={onClose} className="text-[13px] text-slate-500 hover:text-slate-700 font-medium transition-colors" data-id="element-45">
                    Cancel
                  </button>
                  <button type="submit" disabled={!title.trim()} className="px-3 py-1.5 bg-[#5e6ad2] text-white text-[13px] font-medium rounded hover:bg-[#4f5ab8] disabled:opacity-50 disabled:cursor-not-allowed transition-colors shadow-sm" data-id="element-46">
                    Create Issue
                  </button>
                </div>
              </div>
            </form>
          </motion.div>
        </div>}
    </AnimatePresence>;
}